import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../core/modules/shared.module';
import { NgxGalleryModule } from 'ngx-gallery';

import { SimpleListModule } from '../simple-list/simple-list.module';

import { StatsComponent } from './stats.component';

@NgModule({
  declarations: [
    StatsComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    SimpleListModule,
    NgxGalleryModule
  ],
  exports: [StatsComponent]
})
export class StatsModule { }



// WEBPACK FOOTER //
// ./src/app/main/content/stats/stats.module.ts